import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import { triggerHtml } from './triggerHtml'
import { sweetAlertCommonParams } from '../../utils/functions'

export const triggerModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.trigger_modal_title,
    html: triggerHtml,

    willOpen: () => {
      // Display spinner
      // Swal.showLoading(Swal.getConfirmButton())

      const triggerKeyword = $('#trigger-trigger-keyword')

      // Sets old data if there is any
      triggerKeyword.val(oldData.triggerKeyword || '')
      if (oldData.triggerMatchingType) {
        $('input[name="trigger-matching-type"][value="' + oldData.triggerMatchingType + '"]').prop('checked', true)
      }
      
    },  

    preConfirm: () => {
      const triggerKeyword = $('#trigger-trigger-keyword').val()
      const triggerMatchingType = $("input[name='trigger-matching-type']:checked").val()

      if (! triggerKeyword) {
        Swal.showValidationMessage(lang.trigger_modal_msg_keywords)
      }

      return { triggerKeyword, triggerMatchingType }
    },
  })
}